"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kakao = void 0;
var qs = require('qs');
exports.kakao = function (axios) {
    return {
        getKakaoAuthNumber: function (getKakaoAuthNumberRequest) {
            return axios.get('/kakao/auth-number', getKakaoAuthNumberRequest);
        },
        getKakaoConfig: function (getKakaoConfig) {
            return axios.get('/kakao/config', getKakaoConfig);
        },
        putKakaoConfig: function (putKakaoConfig) {
            return axios.put('/kakao/config', putKakaoConfig.data);
        },
        postKakaoConfigPlus: function (postKakaoConfigPlus) {
            return axios.post('/kakao/config/plus', postKakaoConfigPlus.data);
        },
        deleteKakaoConfigPlus: function (deleteKakaoConfigPlus) {
            return axios.delete('/kakao/config/plus', deleteKakaoConfigPlus);
        },
        // 프로필 전체카테고리 조회(플러스친구 아이디 등록)
        getKakaoConfigCategories: function () {
            return axios.get('/kakao/config/categories');
        },
        getKakaoSendList: function (getKakaoSendListRequest) {
            return axios.get('/kakao/send-list', getKakaoSendListRequest);
        },
        // 자동 알림톡 유형 템플릿 조회
        getKakaoAutoTemplatesGroup: function (_a) {
            var pathParams = _a.pathParams, params = _a.params;
            return axios.get("/kakao-templates/auto/group/" + pathParams.groupType + "?mallNo=" + params.mallNo);
        },
        // 사용중인 자동 알림톡 유형 템플릿 조회
        getUsedKakaoAutoTemplatesGroup: function (_a) {
            var pathParams = _a.pathParams, params = _a.params;
            return axios.get("/kakao-templates/auto/group/" + pathParams.groupType + "/used?mallNo=" + params.mallNo);
        },
        // 카카오 알림톡 템플릿유형리스트
        getKakaoAutoTemplateTypes: function (getKakaoAutoTemplateTypesRequest) {
            return axios.get('/kakao-templates/auto/template-types', getKakaoAutoTemplateTypesRequest);
        },
        putKakaoTemplateSetting: function (putKakaoTemplateSettingRequest) {
            return axios.put('/kakao-templates/auto/templates/setting', putKakaoTemplateSettingRequest.data);
        },
        // 카카오 알림톡 템플릿 전체검색
        getKakaoTemplatesAuto: function (getKakaoTemplatesAutoRequest) {
            return axios.get('/kakao-templates/auto/templates', getKakaoTemplatesAutoRequest);
        },
        // 카카오 템플릿 상세조회
        getKakaoTemplatesAutoDetail: function (_a) {
            var pathParams = _a.pathParams, params = _a.params;
            return axios.get("/kakao-templates/auto/templates/" + pathParams.templateNo + "?mallNo=" + params.mallNo);
        },
        // 카카오 템플릿 등록
        postKakaoTemplatesAuto: function (postKakaoTemplatesAutoRequest) {
            return axios.post('/kakao-templates/auto/templates', postKakaoTemplatesAutoRequest.data);
        },
        // 자동 알림톡 유형 템플릿 설정 변경
        putKakaoTemplatesAutoConfig: function (request) {
            return axios.put('/kakao-templates/auto/templates', request.data);
        },
        // 카카오 알림톡 템플릿 수정
        putKakaoTemplateAuto: function (_a) {
            var pathParams = _a.pathParams, data = _a.data;
            return axios.put("/kakao-templates/auto/templates/" + pathParams.templateNo, data);
        },
        // 카카오 템플릿 삭제
        deleteKakaoTemplateAuto: function (_a) {
            var pathParams = _a.pathParams, params = _a.params;
            return axios.delete("/kakao-templates/auto/templates/" + pathParams.templateNo + "?mallNo=" + params.mallNo);
        },
        // 카카오 템플릿 문의하기(검수요청)
        postKakaoTemplateComment: function (_a) {
            var pathParams = _a.pathParams, data = _a.data;
            return axios.post("/kakao-templates/auto/templates/" + pathParams.templateNo + "/comment", data);
        },
        // 카카오 알림톡 템플릿 카테고리 상세조회
        getKakaoTemplatesCategories: function (_a) {
            var pathParams = _a.pathParams, params = _a.params;
            return axios.get("/kakao-templates/auto/categories/" + pathParams.categoryCode + "?mallNo=" + params.mallNo);
        },
        // 알림톡 야간발송 설정
        putKakaoTemplateUseNightSetting: function (putKakaoTemplateUseNightSetting) {
            return axios.put('/kakao-templates/auto/setting/night', putKakaoTemplateUseNightSetting);
        },
        // 고도 카카오알림톡 발신내역 리스트 조회
        getKakaoMessages: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/kakao/messages?" + query);
        },
        putKakaoTemplatesAutoInspection: function (_a) {
            var pathParams = _a.pathParams, data = _a.data;
            return axios.put("/kakao-templates/auto/templates/" + pathParams.templateNo + "/inspection", data);
        },
        getKakaoMessagesPopup: function (request) {
            return axios.get('/kakao/messages/popup', request);
        }
    };
};
